// categoriesApi.js
import { baseApi } from '../baseApi';

export const notificationsApi = baseApi.injectEndpoints({
  reducerPath: 'notificationsApi',
  endpoints: (builder) => ({
    getNotifications: builder.query({
      query: () => '/notifications',
      providesTags: ['Notifications'], // Endpoint for GET /api/categories
    }),
    reportListing: builder.mutation({
      query: (reportData) => ({
        url: '/report/listing',
        method: 'POST',
        body: reportData,
      }),
    }),
    updateReadStatus: builder.mutation({
      query: () => ({ url: '/notifications', method: 'PATCH' }),
      invalidatesTags: ['Notifications'],
    }),

    // You can add more endpoints for categories here if needed
  }),
});

export const {
  useGetNotificationsQuery,
  useReportListingMutation,
  useReportUserMutation,
  useUpdateReadStatusMutation, // Export the auto-generated hook for the getCategories query
  // Add other exported hooks here as you create more endpoints
} = notificationsApi;
